















































































import { Component, Vue } from "vue-property-decorator";
import { ITopic } from "@/models/Topic.model";
import FileUpload from "@/components/shared/FileUpload.vue";
@Component({ components: { FileUpload } })
export default class TopicsForm extends Vue {
  topic: ITopic = {};
  toDelete = "";

  get content() {
    return this.$store.getters.getTopics;
  }

  fixedString = "";
  insertTopic() {
    if (this.topic.description) {
      this.fixedString = this.topic.description.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );
    }
    this.topic.description = this.fixedString;
    this.$emit("insertTopic", this.topic);
    this.topic = {};
  }

  deleteTopic() {
    this.$emit("deleteTopic", this.toDelete);
  }

  submit = true;
  disableSubmit() {
    this.submit = true;
  }

  enableSubmit() {
    this.submit = false;
  }

  uploaded(link: string) {
    this.topic.link = link;
  }
}
